import React from 'react';
import { Tooltip, TooltipProps } from '@openx/components/core';

export function ReachTooltip(props: TooltipProps): JSX.Element {
  return <Tooltip {...props} />;
}
